export class SettingsUserTagsEntity {
  constructor() {
    this.id = null;
    this.enabledFlag = null;
    this.tagName = null;
  }
  getSettingsUserTags() {
    return this;
  }
  setEnabledFlag(flag) {
    this.enabledFlag = flag;
  }
  getEnabledFlag() {
    return this.enabledFlag;
  }
}

export default SettingsUserTagsEntity;
